import React from "react";
import {
  Dialog,
  DialogContent,
  DialogActions,
  Typography,
  Button,
  Box,
} from "@mui/material";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";

function CheckDuplicatePop({ isOpen, onClose, message }) {
  return (
    <Dialog open={isOpen} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogContent sx={{ textAlign: "center", py: 3 }}>
        {/* Icon */}
        <Box sx={{ mb: 1 }}>
          <WarningAmberIcon sx={{ fontSize: 50, color: "#f59e0b" }} />
        </Box>

        {/* Title */}
        <Typography variant="h6" fontWeight="bold" gutterBottom>
          Duplicate Questions Found
        </Typography>

        {/* Message */}
        <Typography
          variant="body2"
          color="text.secondary"
          sx={{ whiteSpace: "pre-line" }}
        >
          {message}
        </Typography>
      </DialogContent>

      <DialogActions sx={{ justifyContent: "center", pb: 2 }}>
        <Button
          variant="contained"
          color="warning"
          onClick={onClose}
          sx={{ px: 4 }}
        >
          Okay
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default CheckDuplicatePop;
